export default __webpack_public_path__ + "static/popup-kerst-afee0f7767378171fd516af0e4886bae.png";